import { ReactNode } from 'react'

type Section = {
  heading: string
  body: ReactNode
}

type Props = {
  updated: string
  intro?: ReactNode
  sections: Section[]
}

export default function ProseContent({ updated, intro, sections }: Props) {
  return (
    <section className="rounded-section bg-white px-6 py-20 md:px-16 md:py-28">
      <div className="mx-auto max-w-3xl">
        <p className="text-[13px] font-semibold uppercase tracking-[0.08em] text-oak-black/40">
          Last updated {updated}
        </p>

        {intro && (
          <div className="mt-6 text-[clamp(16px,1.5vw,19px)] leading-[1.6] tracking-[-0.2px] text-oak-black/70">
            {intro}
          </div>
        )}

        <div className="mt-12 space-y-12">
          {sections.map((section, i) => (
            <div key={i}>
              <h2 className="font-serif text-[clamp(24px,3vw,32px)] leading-tight tracking-[-0.8px] text-oak-black">
                {i + 1}. {section.heading}
              </h2>
              <div className="mt-4 space-y-4 text-[clamp(15px,1.4vw,17px)] leading-[1.6] tracking-[-0.2px] text-oak-black/70">
                {section.body}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
